/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { LogoutResponse, LogoutVars } from '../openapi-types.gen.js';

export type { LogoutResponse, LogoutVars } from '../openapi-types.gen.js';

export const useLogout = createMutationHook<LogoutVars, LogoutResponse, unknown>({
  specName: 'useLogout',
  path: '/v1/auth/logout',
  method: 'POST',
  resolveUrl: (vars: LogoutVars) => `/v1/auth/logout`,
  
  parseResponse: (raw: unknown): LogoutResponse => raw as LogoutResponse,
  
  
  
});
